/* eslint-disable */
(function() {
  var $ = require('jquery');
  require('owl-carousel/owl.carousel.js');

  $('.home-banner').owlCarousel({
    navigation: true,
    autoPlay: 7000,
    slideSpeed: 1000,
    pagination: false,
    singleItem: true,
    afterInit: function() {
      setTimeout(function() {
        $('.animate-banner').addClass('slide-in');
      }, 800);
    },
  });

  $('#widget-banner').owlCarousel({
    navigation: true,
    slideSpeed: 700,
    pagination: false,
    singleItem: true,
  });

  $('#advertise-carousel').owlCarousel({
    navigation: true,
    autoPlay: 7000,
    slideSpeed: 700,
    paginationSpeed: 700,
    pagination: false,
    singleItem: true,
  });

  $('#product-carousel').owlCarousel({
    navigation: false,
    autoPlay: 7000,
    slideSpeed: 700,
    paginationSpeed: 700,
    pagination: true,
    singleItem: true,
  });

  $('.page-banner-inner').owlCarousel({
    navigation: true,
    autoPlay: 7000,
    slideSpeed: 700,
    pagination: false,
    singleItem: true,
  });

  $('.js-page-banner-inner').owlCarousel({
    navigation: true,
    autoPlay: 7000,
    slideSpeed: 1000,
    pagination: false,
    singleItem: true,
  });

  function mediaHeight() {
    //removes inline styles (heights)
    $('.case-box').removeAttr('style');
    if ($(window).innerWidth() > 767) {
      //sets height on media hub items to make them all match.
      $('.media-main')
        .find('.owl-item')
        .each(function() {
          var $item = $(this);
          var newHeight = '0';

          $item.find('.equalHub').each(function() {
            var $col = $(this);

            var colHeight = $col.outerHeight();

            if (colHeight > newHeight) {
              newHeight = colHeight;
            }
            //this checks to see if there are another set of columns inside the item if so it has to get the
            //remaining height difference to add that rather than change the height of each box
            if ($col.find('.col-sm-6').length) {
              $col.addClass('mulitple-box');
              $col.find('.col-sm-6').each(function() {
                var innerColHeight = $(this).outerHeight();

                if (innerColHeight < newHeight) {
                  var differenceInHeight = newHeight - innerColHeight;

                  var currentHeightOfLast = $(this)
                    .find('.case-box:last-child')
                    .outerHeight();
                  $(this)
                    .find('.case-box:last-child')
                    .css('height', currentHeightOfLast + differenceInHeight);
                }
              });
            } else {
              $col.addClass('single-box');
            }
          });

          $item
            .find('.single-box')
            .find('.case-box')
            .css('height', newHeight);
        });
    }
  }

  //media hub carousel
  var mediamain = $('.media-main');
  var mediaview = $('.media-view-carousel');

  mediamain.owlCarousel({
    singleItem: true,
    slideSpeed: 1000,
    navigation: true,
    navigationText: false,
    pagination: false,
    autoHeight: true,
    afterAction: syncPosition,
    responsiveRefreshRate: 200,
    afterInit: function() {
      //on carousel load add the navigation in and the inner spans for the text
      $('.media-hub .owl-prev').append(
        '<span class="owl-nav-prev"></span><span class="text-span text-prev"><span class="inner-span">prev</span></span>',
      );
      $('.media-hub .owl-next').append(
        '<span class="owl-nav-next"></span><span class="text-span text-next"><span class="inner-span">next</span></span>',
      );

      mediaHeight();

      //twitter widget script
      $.getScript('https://platform.twitter.com/widgets.js', function() {
        //calling method load
        twttr.widgets.load();
      });
    },
    afterUpdate: function() {
      mediaHeight();
    },
    afterMove: function() {
      //after moving the text is got from the correct span in the media view carousel and applied to the inner span navigation text

      //timeout is used as it should only be applied after the animation has finished (which is specified up there ^^ as slidespeed)
      setTimeout(function() {
        var currentItem = $('.media-view-carousel .owl-item.synced');
        var currentIndex = currentItem.index() + 1;
        var amountOfItems = $('.media-view-carousel .owl-item').length;
        var nextText = '';
        var prevText = '';

        if (currentIndex < amountOfItems) {
          nextText = currentItem
            .next('.owl-item')
            .find('span')
            .html();
          $('.text-span.text-next .inner-span')
            .empty()
            .append(nextText);

          if (currentIndex === 1) {
            prevText = $('.media-view-carousel .owl-item:last-child')
              .find('span')
              .html();
            $('.text-span.text-prev .inner-span')
              .empty()
              .append(prevText);
          } else {
            prevText = currentItem
              .prev('.owl-item')
              .find('span')
              .html();
            $('.text-span.text-prev .inner-span')
              .empty()
              .append(prevText);
          }
        } else if (currentIndex === amountOfItems) {
          nextText = $('.media-view-carousel .owl-item:first-child')
            .find('span')
            .html();
          $('.text-span.text-next .inner-span')
            .empty()
            .append(nextText);

          prevText = currentItem
            .prev('.owl-item')
            .find('span')
            .html();
          $('.text-span.text-prev .inner-span')
            .empty()
            .append(prevText);
        }
      }, 1000);

      //animate green bar to current position of media view
      var $synced = $('.media-view-carousel .owl-item.synced');
      var currentPosition = $synced.position().left;
      var spanWidth = $synced.find('span').width();
      $('.media-hub .media-view .grey-bar .green-block').css({
        left: currentPosition,
        width: spanWidth,
      });
    },
  });

  mediaview.owlCarousel({
    items: 8,
    itemsDesktop: [1199, 8],
    itemsDesktopSmall: [979, 6],
    itemsTablet: [768, 5],
    itemsMobile: [479, 5],
    pagination: false,
    responsiveRefreshRate: 100,
    afterInit: function(el) {
      //this loads after the initial carousel, so after that has loaded:
      //on load change text inside nav buttons
      var prevText = $('.media-view-carousel .owl-item:last-child')
        .find('span')
        .html();
      $('.text-span.text-prev .inner-span')
        .empty()
        .append(prevText);

      var nextText = $('.media-view-carousel .owl-item:nth-child(2)')
        .find('span')
        .html();
      $('.text-span.text-next .inner-span')
        .empty()
        .append(nextText);

      el.find('.owl-item')
        .eq(0)
        .addClass('synced');
    },
  });

  function syncPosition(el) {
    var current = this.currentItem;
    $('.media-view-carousel')
      .find('.owl-item')
      .removeClass('synced')
      .eq(current)
      .addClass('synced');

    if ($('.media-view-carousel').data('owlCarousel') !== undefined) {
      center(current);
    }
  }

  $('.media-view-carousel').on('click', '.owl-item', function(e) {
    e.preventDefault();
    var number = $(this).data('owlItem');
    mediamain.trigger('owl.goTo', number);
  });

  function center(number) {
    var mediaviewvisible = mediaview.data('owlCarousel').owl.visibleItems;
    var num = number;
    var found = false;
    for (var i in mediaviewvisible) {
      if (num === mediaviewvisible[i]) {
        found = true;
      }
    }

    if (found === false) {
      if (num > mediaviewvisible[mediaviewvisible.length - 1]) {
        mediaview.trigger('owl.goTo', num - mediaviewvisible.length + 2);
      } else {
        if (num - 1 === -1) {
          num = 0;
        }
        mediaview.trigger('owl.goTo', num);
      }
    } else if (num === mediaviewvisible[mediaviewvisible.length - 1]) {
      mediaview.trigger('owl.goTo', mediaviewvisible[1]);
    } else if (num === mediaviewvisible[0]) {
      mediaview.trigger('owl.goTo', num - 1);
    }
  }
})();
